import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../models/alert-info';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { FormService } from '../../../../services/form.service';
import { ValidatorService } from '../../../../services/validator.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { CustomerService } from '../../../../services/api/customer.service';
import { ContentToolbarComponent } from '../../../../components/form/content-toolbar/content-toolbar.component';

@Component({
  selector: 'app-customers-message',
  imports: [NgbAlert, CommonModule, ReactiveFormsModule, InputFieldComponent, ContentToolbarComponent],
  templateUrl: './customers-message.component.html',
  styleUrl: './customers-message.component.scss'
})
export class CustomersMessageComponent implements OnInit {
  messages?: any;
  @Input() readonlyTranslationsDetails: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();


  languages: { code: 'eng' | 'ita' | 'spa'; flag: string; label: string }[] = [
    { code: 'eng', flag: '/assets/flags/uk.svg', label: 'English' },
    { code: 'ita', flag: '/assets/flags/it.svg', label: 'Italiano' },
    { code: 'spa', flag: '/assets/flags/es.svg', label: 'Español' }
  ];

  activeTab: string = 'eng';
  form!: FormGroup;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private customersService: CustomerService,
  ) {
    this.customersService.listSettingsMessages().subscribe((response: any) => {
      this.messages = response?.data?.customerWelcomeLetters;

      if (this.messages) {   

        this.languages = this.messages.map((message: any) => ({
          code: message.language.iso3,
          flag: `/assets/flags/${message.language.iso2}.svg`,
          label: message.language.name,
        }));
        this.updateFormValues(this.activeTab);
      }
    });

    this.form = new FormGroup({
      subject: new FormControl('', [Validators.required]),
      message: new FormControl('', [Validators.required]),
    });
  }
  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['messages'] && changes['messages'].currentValue) {
      this.form.patchValue({
        subject: changes['messages'].currentValue?.subject,
        message: changes['messages'].currentValue?.message,
      });
    }
  }


  /**
     * *******************
     * Submit form methods
     * *******************
     */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });
     const selectedMessage = this.messages?.find(
        (message: any) => message.language.iso3 === this.activeTab
      );

    if (this.form.valid) {
      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
          languageId: selectedMessage?.language?.languageId,
        },
      );

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = selectedMessage
        ? this.customersService.updateSettingsMessages(selectedMessage.customerWelcomeLetterId, values)
        : this.customersService.createSettingsMessages(values);

      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response);
        },
        error: (error: any) => {
          this.submitFormError(error);
        },
      });
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  getSubjectInput(): FormControl { return this.getFormControl('subject'); }
  getContentInput(): FormControl { return this.getFormControl('message'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }

  onTabChange(langCode: 'eng' | 'ita' | 'spa'): void {
    this.activeTab = langCode;
    if (this.messages) {
      this.updateFormValues(langCode);
    }
  }

  private updateFormValues(langCode: string): void {
    const selectedMessage = this.messages?.find(
      (message: any) => message.language.iso3 === langCode
    );

    if (selectedMessage) {
      this.form.patchValue({
        subject: selectedMessage.subject,
        message: selectedMessage.message,
      });
    }
  }
}
